import DesignVariations from "../../Portal/Accessor/DesignVariation/DesignVariations";
import DesignVariationDetail from "../../Portal/Accessor/DesignVariation/DesignVariationDetail";
const AccessorDesignVariationRouters = [
    {
      path: "DesignVariationAssessor/DesignVariations/:projectId",
      exact: true,
      requireAuth: true,
      element: <DesignVariations/>,
      title: "Design Variations | AccuRate Enterprise",
    },
    {
      path: "DesignVariationAssessor/Detail/:projectId/:designVariationId",
      exact: true,
      requireAuth: true,
      element: <DesignVariationDetail/>,
      title: "Design Variation | AccuRate Enterprise",
    },
  ];
export default AccessorDesignVariationRouters;